import { useQuery } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'
import { request } from '@/utils/axiosUtil'

export default function useHomeService() {
  const router = useRouter()
  const dispatch = useDispatch()
  const apiUrl = '/home'
  const getHomePageData = async () => {
    const res = await request({ url: apiUrl })
    if (res?.status == 200) {
      return res?.data?.data
    } else {
      router.push(`/${res?.response?.status || res?.status}`)
      return res?.response?.data
    }
  }

  return useQuery(['homeService'], () => getHomePageData(), {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    useErrorBoundary: true,
  })
}
